
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
    Legend,
} from 'recharts'

export function SalesComparisonChart({ salesComparison }: { salesComparison: any[] }) {
    const branches = salesComparison.length > 0 
        ? Object.keys(salesComparison[0]).filter(key => key !== 'month')
        : []
    
    const colors = ['#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6', '#ec4899', '#14b8a6']

    return (
        <div className="rounded-lg border border-slate-200 bg-white p-6">
            <h3 className="mb-4 font-semibold text-slate-900">
                Comparativo de Ventas por Sucursal
            </h3>
            <ResponsiveContainer width="100%" height={300}>
                <LineChart data={salesComparison}>
                    <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
                    <XAxis dataKey="month" stroke="#64748b" />
                    <YAxis stroke="#64748b" />
                    <Tooltip
                        contentStyle={{
                            backgroundColor: '#fff',
                            border: '1px solid #e2e8f0',
                            borderRadius: '8px',
                        }}
                    />
                    <Legend />
                    {branches.map((branch, index) => (
                        <Line
                            key={branch}
                            type="monotone"
                            dataKey={branch}
                            stroke={colors[index % colors.length]}
                            strokeWidth={2}
                            name={branch}
                            dot={{ r: 4 }}
                        />
                    ))}
                </LineChart>
            </ResponsiveContainer>
        </div>
    )
}